// src/main.ts
import './tailwind.css'; // Importe d'abord le fichier Tailwind
import './style.css';    // Puis le fichier de style principal
import './styles/animations.css';
import "./styles/components/button-fix.css"; // Import corrigé
import "./styles/components/modal-fixes.css";
import "./styles/components/modal-mobile-fixes.css"; // Import des corrections mobile
import './styles/gradients.css';
import './styles/components/formation-packages.css'; // Import des styles pour les packages de formations
import './styles/components/formations-harmonization.css'; // Import pour harmoniser les formations
import './styles/components/modal-service-harmonization.css'; // Import pour harmoniser les modales des services
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';
import Hero from './components/sections/Hero';
import Services from './components/sections/Services';
import Formations from './components/sections/Formations';
import { renderServices } from './utils/renderServices';
import { BlogController } from './components/BlogController';
import { articles } from './data/articles';
import { BlogUtils } from "./utils/blogUtils-new"; // Utilisation de la nouvelle version
import './utils/spacingUtils'; // Import du correctif d'espacement consolidé
import './utils/newsletter'; // Import du gestionnaire de newsletter
import './utils/modalEnhancer'; // Import de l'améliorateur de modales (migration JS->TS)
import './utils/modalServiceHarmonizer'; // Import de l'harmonisateur de modales (migration JS->TS)
// Fix favicon in production: resolve to built URL
// Vite will transform this import into the correct public path
import faviconUrl from './assets/logo won 5-favicon.png';

// Import des nouveaux systèmes Option 4
import ToastManager from './utils/ToastManager';
import CookieManager from './utils/CookieManager';
import AnimationManager from './utils/AnimationManager';

// Import du chatbot WON intelligent avec IA
import './components/chatbot/SmartChatbotInitializer';

// Import du nouveau système de modales V2
import { ModalSystemV2 } from './components/modals-v2';

// Initialisation du système de modales V2 en production
ModalSystemV2.initProduction();


// === Instanciation des utils
const blogUtils = new BlogUtils();

document.addEventListener("DOMContentLoaded", () => {
  ensureFavicon();
  initApp();
  const servicesContainer = document.getElementById('services-container');
  if (servicesContainer) {
    renderServices('services-container');
  }
  renderBlogSections();
});

/**
 * Injecte dynamiquement les articles dans les sections du blog
 */
function renderBlogSections() {
  const featuredContainer = document.querySelector(".featured-article") as HTMLElement | null;
  const recentContainer = document.querySelector(".recent-articles") as HTMLElement | null;
  const allContainer = document.querySelector(".all-articles") as HTMLElement | null;

  if (!articles || articles.length === 0) return;

  // Extraction des catégories uniques pour les filtres
  const categories = [...new Set(articles
    .filter(article => article.category)
    .map(article => article.category))]
    .sort();

  // Articles récents en format moderne avec filtres
  if (recentContainer) {
    // Ajout des filtres
    let filtersHTML = `
      <div class="blog-filters" style="display: flex; justify-content: center; margin-bottom: 2rem; gap: 0.75rem; flex-wrap: wrap;">
        <button class="blog-filter-button active" data-category="all" style="background-color: rgba(20, 30, 40, 0.3); color: #ecf0f1; 
                border: 1px solid rgba(52, 152, 219, 0.2); border-radius: 20px; padding: 0.5rem 1rem; font-size: 0.875rem; 
                font-weight: 600; cursor: pointer; transition: all 0.3s ease;">Tous</button>
    `;
    
    categories.forEach(category => {
      filtersHTML += `
        <button class="blog-filter-button" data-category="${category}" style="background-color: rgba(20, 30, 40, 0.3); color: #ecf0f1; 
                border: 1px solid rgba(52, 152, 219, 0.2); border-radius: 20px; padding: 0.5rem 1rem; font-size: 0.875rem; 
                font-weight: 600; cursor: pointer; transition: all 0.3s ease;">${category}</button>
      `;
    });
    
    filtersHTML += '</div>';
    
    // Créer la grille d'articles modernisée
    let gridHTML = `
      <div class="modern-blog-layout" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.5rem; 
                  max-width: 1400px; margin: 0 auto 2rem; padding: 0 2rem;">
    `;
    
    // Ajouter les articles
    articles.forEach(article => {
      const card = blogUtils.createArticleCard(article);
      const category = article.category || 'Article';
      const readTime = article.metadata?.readingTime || 5;
      
      gridHTML += blogUtils.renderModernCard(card, category, readTime);
    });
    
    gridHTML += '</div>';
    
    // Ajouter le bouton "Voir plus" APRÈS la grille
    const buttonHTML = `
      <div style="display: flex; justify-content: center; margin-top: 2rem; margin-bottom: 2rem;">
        <button id="voir-plus-articles-btn" style="background-color: rgba(20, 30, 40, 0.3); color: #ecf0f1; 
                border: 2px solid #3498db; border-radius: 30px; padding: 0.75rem 2rem; font-size: 1rem; 
                font-weight: 600; cursor: pointer; transition: all 0.3s ease; display: flex; 
                align-items: center; gap: 0.5rem; border: none;">
          Voir plus d'articles
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
               style="width: 20px; height: 20px; transition: transform 0.3s ease;">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 14l-7 7m0 0l-7-7m7 7V3"/>
          </svg>
        </button>
      </div>
    `;
    
    recentContainer.innerHTML = filtersHTML + gridHTML + buttonHTML;
    
    // Ajouter le script de filtrage
    setTimeout(() => {
      const filterButtons = document.querySelectorAll<HTMLElement>('.blog-filter-button');
      const blogCards = document.querySelectorAll<HTMLElement>('.modern-blog-card');
      
      filterButtons.forEach(button => {
        button.addEventListener('click', function() {
          // Réinitialiser tous les boutons
          filterButtons.forEach((btn: HTMLElement) => {
            btn.classList.remove('active');
            btn.style.backgroundColor = 'rgba(20, 30, 40, 0.3)';
            btn.style.color = '#ecf0f1';
            btn.style.transform = 'translateY(0)';
            btn.style.boxShadow = 'none';
          });
          
          // Activer le bouton cliqué
          this.classList.add('active');
          this.style.backgroundColor = '#3498db';
          this.style.color = 'white';
          this.style.transform = 'translateY(-2px)';
          this.style.boxShadow = '0 4px 10px rgba(52, 152, 219, 0.3)';
          
          const category = this.getAttribute('data-category');
          
          // Filtrer les cartes
          blogCards.forEach((card: HTMLElement) => {
            if (category === 'all') {
              card.style.display = 'block';
              setTimeout(() => {
                card.style.opacity = '1';
                card.style.transform = 'translateY(0)';
              }, 50);
            } else {
              if (card.getAttribute('data-category') === category) {
                card.style.display = 'block';
                setTimeout(() => {
                  card.style.opacity = '1';
                  card.style.transform = 'translateY(0)';
                }, 50);
              } else {
                card.style.opacity = '0';
                card.style.transform = 'translateY(20px)';
                setTimeout(() => {
                  card.style.display = 'none';
                }, 300);
              }
            }
          });
        });
      });
      
      // Ajouter effet de survol aux cartes
      blogCards.forEach((card: HTMLElement) => {
        card.addEventListener('mouseenter', function(this: HTMLElement) {
          this.style.transform = 'translateY(-5px)';
          
          // Récupérer l'image et l'agrandir
          const img = this.querySelector('img') as HTMLElement | null;
          if (img) img.style.transform = 'scale(1.1)';
          
          // Changer la couleur du texte "Lire la suite"
          const readMore = this.querySelector('div[style*="color: #3498db"]') as HTMLElement | null;
          if (readMore) readMore.style.color = '#ed4c67';
          
          // Déplacer la flèche de "Lire la suite"
          const arrow = this.querySelector('svg[style*="margin-left"]') as HTMLElement | null;
          if (arrow) arrow.style.transform = 'translateX(5px)';
        });
        
        card.addEventListener('mouseleave', function(this: HTMLElement) {
          this.style.transform = 'translateY(0)';
          
          // Réinitialiser l'image
          const img = this.querySelector('img') as HTMLElement | null;
          if (img) img.style.transform = 'scale(1)';
          
          // Réinitialiser la couleur du texte "Lire la suite"
          const readMore = this.querySelector('div[style*="color:"]') as HTMLElement | null;
          if (readMore) readMore.style.color = '#3498db';
          
          // Réinitialiser la position de la flèche
          const arrow = this.querySelector('svg[style*="margin-left"]') as HTMLElement | null;
          if (arrow) arrow.style.transform = 'translateX(0)';
        });
      });
      
      // Ajouter l'event listener pour le bouton "Voir plus d'articles"
      const voirPlusBtn = document.getElementById('voir-plus-articles-btn');
      if (voirPlusBtn) {
        voirPlusBtn.addEventListener('click', function() {
          const targetSection = document.getElementById('tous-les-articles');
          if (targetSection) {
            // Animation smooth scroll avec décalage pour la navbar fixe
            const offsetTop = targetSection.offsetTop - 100; // 100px pour compenser la navbar
            window.scrollTo({
              top: offsetTop,
              behavior: 'smooth'
            });
            
            // Effet visuel sur le bouton
            this.style.transform = 'scale(0.95)';
            setTimeout(() => {
              this.style.transform = 'scale(1)';
            }, 150);
          }
        });
        
        // Effet de survol amélioré pour le bouton
        voirPlusBtn.addEventListener('mouseenter', function() {
          this.style.backgroundColor = '#3498db';
          this.style.transform = 'translateY(-2px)';
          this.style.boxShadow = '0 8px 20px rgba(52, 152, 219, 0.3)';
          const arrow = this.querySelector('svg');
          if (arrow) arrow.style.transform = 'translateY(2px)';
        });
        
        voirPlusBtn.addEventListener('mouseleave', function() {
          this.style.backgroundColor = 'rgba(20, 30, 40, 0.3)';
          this.style.transform = 'translateY(0)';
          this.style.boxShadow = 'none';
          const arrow = this.querySelector('svg');
          if (arrow) arrow.style.transform = 'translateY(0)';
        });
      }
    }, 100);
  }

  // Tous les articles (affichage horizontal avec navigation)
  if (allContainer) {
    allContainer.innerHTML = `
      <div class="carousel-container">
        <button class="carousel-nav-button carousel-prev" aria-label="Précédent">
          <svg viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/>
          </svg>
        </button>
        
        <div class="horizontal-articles-container">
          ${articles.map(article => {
            const card = blogUtils.createArticleCard(article);
            return `
              <div class="article-card">
                <a href="single-article.html?slug=${card.slug}">
                  <div class="image-container">
                    <img src="${card.image}" alt="Illustration de l'article ${card.title}">
                  </div>
                  <div class="card-content">
                    <time>${card.date}</time>
                    <h3 class="line-clamp-2">${card.title}</h3>
                    <p class="line-clamp-3">${card.excerpt}</p>
                    <span class="read-more">
                      Lire la suite
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/>
                      </svg>
                    </span>
                  </div>
                </a>
              </div>
            `;
          }).join('')}
        </div>
        
        <button class="carousel-nav-button carousel-next" aria-label="Suivant">
          <svg viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/>
          </svg>
        </button>
      </div>
      
      <div class="carousel-pagination">
        <span class="dot active"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
    `;
    
    // Initialiser la navigation du carousel
    if (allContainer) initializeCarousel(allContainer);
  }

  // Masquer le featuredContainer puisqu'il n'est plus nécessaire
  if (featuredContainer) {
    featuredContainer.style.display = 'none';
  }
}

function ensureFavicon() {
  try {
    const ensure = (rel: string) => {
      let link = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link');
        link.rel = rel as any;
        document.head.appendChild(link);
      }
      link.href = faviconUrl;
      link.type = 'image/png';
    };
    ensure('icon');
    ensure('shortcut icon');
    const apple = document.querySelector('link[rel="apple-touch-icon"]') as HTMLLinkElement | null;
    if (apple) apple.href = faviconUrl;
  } catch {}
}

// NOTE: Nous utilisons le BlogController UNIQUEMENT pour la page single-article.html
// Notre propre code gère la page blog.html
const blogController = new BlogController();

// Vérifier si nous sommes sur la page single-article.html
if (window.location.pathname.includes('single-article.html')) {
  blogController.initialize();
}

/**
 * Initialise l'application World Of Numeric
 */
function initApp() {
  // Initialiser les nouveaux systèmes Option 4
  console.log('🚀 Initialisation World Of Numeric - Option 4');
  CookieManager.init();
  AnimationManager.init();
  
  // Initialiser le nouveau système de modales V2
  ModalSystemV2.migrateToV2().then(() => {
    console.log('✅ Système de modales V2 initialisé avec succès');
  }).catch((error) => {
    console.error('❌ Erreur lors de l\'initialisation du système de modales V2:', error);
  });
  
  // Initialiser la Navbar sur toutes les pages
  Navbar.initialize();
  
  // Initialiser le Footer et autres composants communs
  initCommonComponents();

  const currentPath = window.location.pathname;
  const isHomePage = currentPath === '/' || currentPath.endsWith('index.html');

  if (isHomePage) {
    initHomePageOriginal();
  } else {
    initPageSpecificFeatures(currentPath);
  }
}

/**
 * Page d'accueil
 */
function initHomePageOriginal() {
  const app = document.querySelector<HTMLDivElement>('#app');

  if (!app) {
    console.error("L'élément #app n'a pas été trouvé dans le DOM");
    return;
  }

  const mainContent = document.createElement('div');
  mainContent.className = 'min-h-screen flex flex-col';

  const content = document.createElement('main');
  content.className = 'flex-grow';

  const heroSection = new Hero();
  const servicesSection = new Services();
  const formationsSection = new Formations();

  content.appendChild(heroSection.getElement());
  content.appendChild(servicesSection.getElement());
  content.appendChild(formationsSection.getElement());

  mainContent.appendChild(content);
  app.appendChild(mainContent);
}

/**
 * Composants communs
 */
function initCommonComponents() {
  // La navbar est maintenant initialisée par Navbar.initialize()
  // Ne pas créer une deuxième instance ici
  
  const footer = new Footer();
  document.body.appendChild(footer.getElement());
}

/**
 * Pages spécifiques
 */
function initPageSpecificFeatures(currentPath: string) {
  if (currentPath.endsWith('contact.html')) {
    initContactPage();
  }
}

/**
 * Formulaire de contact
 */
function initContactPage() {
  const contactForm = document.getElementById('contactForm') as HTMLFormElement | null;
  if (contactForm) setupContactForm(contactForm);
  setupParallaxEffect();
}

function setupContactForm(form: HTMLFormElement) {
  form.addEventListener('submit', function(e) {
    e.preventDefault();

    let isValid = true;
    const inputs = form.querySelectorAll('input, textarea');

    inputs.forEach(input => {
      const value = (input as HTMLInputElement | HTMLTextAreaElement).value.trim();

      if (value === '') {
        isValid = false;
        input.classList.add('border-red-500');
        let errorMsg = input.parentElement?.querySelector('.error-message');
        if (!errorMsg) {
          errorMsg = document.createElement('div');
          errorMsg.className = 'error-message text-red-500 text-sm mt-1';
          errorMsg.textContent = 'Ce champ est requis';
          input.parentElement?.appendChild(errorMsg);
        }
      } else {
        input.classList.remove('border-red-500');
        input.classList.add('border-green-500');
        const errorMsg = input.parentElement?.querySelector('.error-message');
        if (errorMsg) errorMsg.remove();
      }
    });

    if (isValid) {
      const submitBtn = form.querySelector('button[type="submit"]') as HTMLButtonElement | null;
      const originalText = submitBtn?.querySelector('span')?.textContent || '';

      if (submitBtn) {
        submitBtn.disabled = true;
        if (submitBtn.querySelector('span')) {
          submitBtn.querySelector('span')!.innerHTML = '<svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>Envoi en cours...';
        }
      }

      setTimeout(() => {
        showToast('Message envoyé avec succès !', 'success');
        form.reset();
        inputs.forEach(input => input.classList.remove('border-red-500', 'border-green-500'));
        if (submitBtn) {
          submitBtn.disabled = false;
          if (submitBtn.querySelector('span')) {
            submitBtn.querySelector('span')!.textContent = originalText;
          }
        }
      }, 2000);
    } else {
      showToast('Veuillez corriger les erreurs dans le formulaire', 'error');
    }
  });
}

function showToast(message: string, type: 'success' | 'error') {
  const toast = document.createElement('div');
  toast.className = `fixed bottom-4 right-4 px-6 py-3 rounded-lg text-white transform transition-all duration-300 translate-y-10 opacity-0 z-50 ${
    type === 'success' ? 'bg-green-500' : 'bg-red-500'
  }`;
  toast.textContent = message;
  document.body.appendChild(toast);

  setTimeout(() => toast.classList.remove('translate-y-10', 'opacity-0'), 100);
  setTimeout(() => {
    toast.classList.add('translate-y-10', 'opacity-0');
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}

function setupParallaxEffect() {
  document.addEventListener('mousemove', (e) => {
    const x = e.clientX / window.innerWidth;
    const y = e.clientY / window.innerHeight;
    const layers = document.querySelectorAll('.parallax-layer');
    layers.forEach(layer => {
      const depth = layer.getAttribute('data-depth') || '0.2';
      const moveX = (x - 0.5) * 40 * parseFloat(depth);
      const moveY = (y - 0.5) * 40 * parseFloat(depth);
      (layer as HTMLElement).style.transform = `translate(${moveX}px, ${moveY}px)`;
    });
  });
}

/**
 * Initialise les fonctionnalités du carousel d'articles avec améliorations 2025
 * - Navigation par boutons et clavier
 * - Défilement tactile amélioré
 * - Pagination
 * - Cards adaptatives
 * - Accessibilité renforcée
 * - Snap scrolling
 */
function initializeCarousel(container: HTMLElement) {
  const carousel = container.querySelector('.horizontal-articles-container') as HTMLElement;
  const prevButton = container.querySelector('.carousel-prev') as HTMLButtonElement;
  const nextButton = container.querySelector('.carousel-next') as HTMLButtonElement;
  const dots = container.querySelectorAll('.carousel-pagination .dot');
  
  if (!carousel || !prevButton || !nextButton) return;
  
  // Variables pour le défilement et les gestures
  let isDragging = false;
  let startPosition = 0;
  let scrollLeft = 0;
  let currentIndex = 0;
  let totalArticles = carousel.children.length;
  
  // === 7. CARDS ADAPTATIVES ===
  function getVisibleCards(): number {
    const containerWidth = carousel.offsetWidth;
    const cardWidth = 290 + 20; // largeur carte + gap
    return Math.max(1, Math.floor(containerWidth / cardWidth));
  }
  
  function getCardWidth(): number {
    return carousel.querySelector('.article-card')?.clientWidth || 290;
  }
  
  // === 10. ACCESSIBILITÉ RENFORCÉE ===
  function updateAccessibility() {
    const visibleCards = getVisibleCards();
    const maxIndex = Math.max(0, totalArticles - visibleCards);
    
    prevButton.setAttribute('aria-label', `Article précédent (${currentIndex + 1}/${totalArticles})`);
    nextButton.setAttribute('aria-label', `Article suivant (${Math.min(currentIndex + visibleCards, totalArticles)}/${totalArticles})`);
    
    // Désactiver les boutons si nécessaire
    prevButton.disabled = currentIndex === 0;
    nextButton.disabled = currentIndex >= maxIndex;
    
    // Styles pour boutons désactivés
    prevButton.style.opacity = prevButton.disabled ? '0.5' : '1';
    nextButton.style.opacity = nextButton.disabled ? '0.5' : '1';
    prevButton.style.cursor = prevButton.disabled ? 'not-allowed' : 'pointer';
    nextButton.style.cursor = nextButton.disabled ? 'not-allowed' : 'pointer';
    
    // ARIA pour le carousel
    carousel.setAttribute('role', 'region');
    carousel.setAttribute('aria-label', 'Carousel d\'articles');
    carousel.setAttribute('aria-live', 'polite');
  }
  
  // === NAVIGATION AMÉLIORÉE ===
  function scrollToIndex(index: number) {
    const cardWidth = getCardWidth();
    const scrollDistance = index * (cardWidth + 20);
    carousel.scrollTo({
      left: scrollDistance,
      behavior: 'smooth'
    });
    currentIndex = index;
    updateAccessibility();
    updatePagination();
  }
  
  // Navigation par boutons avec cards adaptatives
  prevButton.addEventListener('click', () => {
    if (currentIndex > 0) {
      const visibleCards = getVisibleCards();
      const newIndex = Math.max(0, currentIndex - visibleCards);
      scrollToIndex(newIndex);
    }
  });
  
  nextButton.addEventListener('click', () => {
    const visibleCards = getVisibleCards();
    const maxIndex = Math.max(0, totalArticles - visibleCards);
    if (currentIndex < maxIndex) {
      const newIndex = Math.min(maxIndex, currentIndex + visibleCards);
      scrollToIndex(newIndex);
    }
  });
  
  // === 1. NAVIGATION AU CLAVIER ===
  function handleKeyboardNavigation(e: KeyboardEvent) {
    // Vérifier si le carousel ou un de ses enfants a le focus
    if (!container.contains(document.activeElement)) return;
    
    switch(e.key) {
      case 'ArrowLeft':
        e.preventDefault();
        if (!prevButton.disabled) prevButton.click();
        break;
      case 'ArrowRight':
        e.preventDefault();
        if (!nextButton.disabled) nextButton.click();
        break;
      case 'Home':
        e.preventDefault();
        scrollToIndex(0);
        break;
      case 'End':
        e.preventDefault();
        const maxIndex = Math.max(0, totalArticles - getVisibleCards());
        scrollToIndex(maxIndex);
        break;
    }
  }
  
  // Ajouter la navigation clavier
  document.addEventListener('keydown', handleKeyboardNavigation);
  
  // Rendre le carousel focusable
  carousel.setAttribute('tabindex', '0');
  carousel.addEventListener('focus', () => {
    carousel.style.outline = '2px solid #3498db';
  });
  carousel.addEventListener('blur', () => {
    carousel.style.outline = 'none';
  });
  
  // === 8. GESTURES TACTILES AMÉLIORÉS ===
  let startX = 0, startY = 0, distX = 0, distY = 0;
  let isScrolling = false;
  
  function handleTouchStart(e: TouchEvent) {
    const touch = e.touches[0];
    startX = touch.clientX;
    startY = touch.clientY;
    isScrolling = false;
    startPosition = startX;
    scrollLeft = carousel.scrollLeft;
  }
  
  function handleTouchMove(e: TouchEvent) {
    if (!startX || !startY) return;
    
    const touch = e.touches[0];
    distX = touch.clientX - startX;
    distY = touch.clientY - startY;
    
    // Déterminer la direction du scroll
    if (!isScrolling) {
      isScrolling = Math.abs(distX) > Math.abs(distY);
    }
    
    // Si c'est un scroll horizontal, empêcher le scroll vertical
    if (isScrolling) {
      e.preventDefault();
      carousel.scrollLeft = scrollLeft - distX;
    }
  }
  
  function handleTouchEnd(e: TouchEvent) {
    if (!isScrolling) return;
    
    const cardWidth = getCardWidth() + 20; // largeur + gap
    const threshold = cardWidth * 0.3; // 30% d'une carte
    
    if (Math.abs(distX) > threshold) {
      if (distX > 0) {
        // Swipe vers la droite (précédent)
        if (!prevButton.disabled) prevButton.click();
      } else {
        // Swipe vers la gauche (suivant)  
        if (!nextButton.disabled) nextButton.click();
      }
    } else {
      // Retour à la position d'origine si le swipe n'est pas assez fort
      carousel.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
    }
    
    // Reset
    startX = startY = distX = distY = 0;
    isScrolling = false;
  }
  
  // Event listeners pour les touches
  carousel.addEventListener('touchstart', handleTouchStart, { passive: false });
  carousel.addEventListener('touchmove', handleTouchMove, { passive: false });
  carousel.addEventListener('touchend', handleTouchEnd);
  
  // Défilement souris amélioré
  carousel.addEventListener('mousedown', (e) => {
    isDragging = true;
    startPosition = e.pageX - carousel.offsetLeft;
    scrollLeft = carousel.scrollLeft;
    carousel.style.cursor = 'grabbing';
    carousel.style.userSelect = 'none';
  });
  
  carousel.addEventListener('mouseleave', () => {
    isDragging = false;
    carousel.style.cursor = 'grab';
    carousel.style.userSelect = 'auto';
  });
  
  carousel.addEventListener('mouseup', () => {
    isDragging = false;
    carousel.style.cursor = 'grab';
    carousel.style.userSelect = 'auto';
    updatePagination();
  });
  
  carousel.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - carousel.offsetLeft;
    const walk = (x - startPosition) * 1.5; // Multiplicateur de vitesse ajusté
    carousel.scrollLeft = scrollLeft - walk;
  });
  
  // === PAGINATION AMÉLIORÉE ===
  function updatePagination() {
    if (!dots.length) return;
    
    const scrollPosition = carousel.scrollLeft;
    const maxScroll = carousel.scrollWidth - carousel.clientWidth;
    const scrollPercentage = maxScroll > 0 ? scrollPosition / maxScroll : 0;
    
    // Calculer l'index actuel basé sur la position
    const cardWidth = getCardWidth() + 20;
    const newIndex = Math.round(scrollPosition / cardWidth);
    currentIndex = Math.max(0, Math.min(newIndex, totalArticles - 1));
    
    // Diviser le carousel en sections selon le nombre de points
    const activeDotIndex = Math.min(
      Math.floor(scrollPercentage * dots.length),
      dots.length - 1
    );
    
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === activeDotIndex);
      // Accessibilité pour les dots
      (dot as HTMLElement).setAttribute('aria-label', `Aller à la section ${index + 1}`);
      (dot as HTMLElement).setAttribute('role', 'button');
      (dot as HTMLElement).setAttribute('tabindex', '0');
    });
    
    updateAccessibility();
  }
  
  // Cliquer sur les points de pagination
  dots.forEach((dot, index) => {
    const handleDotClick = () => {
      const scrollWidth = carousel.scrollWidth - carousel.clientWidth;
      const scrollTo = (index / (dots.length - 1)) * scrollWidth;
      
      carousel.scrollTo({
        left: scrollTo,
        behavior: 'smooth'
      });
      
      // Mettre à jour l'affichage de la pagination
      dots.forEach((d, i) => {
        d.classList.toggle('active', i === index);
      });
    };
    
    dot.addEventListener('click', handleDotClick);
    
    // Support clavier pour les dots
    dot.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleDotClick();
      }
    });
  });
  
  // Mettre à jour la pagination lors du défilement avec throttling
  let ticking = false;
  carousel.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        updatePagination();
        ticking = false;
      });
      ticking = true;
    }
  });
  
  // Gestion du redimensionnement de la fenêtre
  let resizeTimeout: NodeJS.Timeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      updateAccessibility();
      updatePagination();
    }, 250);
  });
  
  // Initialisation
  updateAccessibility();
  updatePagination();
  
  // Cleanup function (optionnel, pour éviter les fuites mémoire)
  return () => {
    document.removeEventListener('keydown', handleKeyboardNavigation);
    window.removeEventListener('resize', () => updateAccessibility());
  };
}
